<template>
    <div class="RequestManagementSearchPanel">
      <box class="" :title="this.$t('search')">
        <div class="px-3 pt-2">
          <v-row>
            <v-col>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <label>{{ $t("fromDate") }} : </label>
                      </td>
                      <td>
                        <div>
                          <dialog-date-picker
                            :label="$t('fromDate') + ':'"
                            :initDate="initBeginDate"
                            @dateResult="bDate"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>{{ $t("toDate") }} : </label>
                      </td>
                      <td>
                        <div>
                          <dialog-date-picker
                            :label="$t('toDate') + ':'"
                            :initDate="initEndDate"
                            @dateResult="eDate"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="personelByName"
                          >{{ $t("personelByName") }}:
                        </label>
                      </td>
                      <td>
                        <div>
                          <v-select
                            hide-details
                            v-model="personel"
                            :items="personelList"
                            :label="$t('personelByName')"
                            item-text="PersonName"
                            item-value="PerNo"
                            return-object
                            dense
                            solo
                            v-on:change="changePersonelByName"
                            class="my-auto py-0"
                          ></v-select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="personelByPerno"
                          >{{ $t("personelByPerno") }}:
                        </label>
                      </td>
                      <td>
                        <div>
                          <v-text-field
                            hide-details
                            v-model.lazy="personelPerno"
                            :label="$t('personelByPerno')"
                            @change="changePersonelPerno"
                            dense
                            solo
                            class="my-auto py-0"
                          ></v-text-field>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="requestType">{{ $t("requestType") }}:</label>
                      </td>
                      <td>
                        <div>
                          <v-select
                            hide-details
                            v-model="requestType"
                            :items="requestTypes"
                            :label="$t('requestType')"
                            item-text="Name"
                            item-value="Code"
                            return-object
                            dense
                            solo
                            v-on:change="changeRequestType"
                            class="my-auto py-0"
                          ></v-select>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
          </v-card-actions>
        </div>
      </box>
    </div>
  </template>
  
  <script>
  import type from "../../model/RequestAdminType";
  import ioType from "../../model/IORequestType";
  import ResultType from "../../model/ResultType";
  import DialogDatePicker from "../widget/DialogDatePicker.vue";
  export default {
    props: {
      accessTo: Number,
      searchType: String,
    },
    components: { DialogDatePicker },
    data() {
      return {
        requestTypes: [],
        requestType: "",
        initBeginDate: null,
        beginDate: "",
        initEndDate: null,
        endDate: "",
        personelList: [],
        personel: {},
        personelPerno: "",
        numberOfType:0
      };
    },
    mounted() {
      //debugger
      var moment = require("jalali-moment");
      var year = moment().locale("fa").format("YYYY");
      this.initBeginDate = year + "/01/01";
  
      this.initEndDate = moment().locale("fa").endOf("year").format("YYYY/MM/DD");
  
      if (this.searchType && this.searchType == "io") {
        this.requestTypes = ioType.IORequestTypeArray();
        this.numberOfType=this.accessTo;
      } else {
        this.requestTypes = type.RequestTypeArray();
      }
  
      if (this.requestTypes.length > 0) {
        this.requestType = this.requestTypes[0];
      }
      switch(this.accessTo) {
    case 0:
      // code block
      break;
    case 1:
      this.numberOfType=57;
      // IO
      break;
    case 2:
    this.numberOfType=56;
      // Mission
      break;
    case 3:
    this.numberOfType=55;
      // Vacation
      break;
    case 4:
    this.numberOfType=58;
      // ExtraWork
      break;
    default:
      // code block
  }
  
  
  
      this.getPersonelList();
    },
  
    methods: {
      bDate(date) {
        this.beginDate = date;
      },
      eDate(date) {
        this.endDate = date;
      },
      getPersonelList() {
        var aa = this.accessTo;
        console.log(aa);
        //debugger
        this.$store.dispatch("GetAccessPersonListWithParam", this.numberOfType).then((result) => {
          //console.log(result);
          if (result.type == ResultType.success) {
            //debugger;
            this.personelList = result.data;
            if (this.personelList.length > 0) {
              //debugger;
              this.personel = this.personelList[0];
              this.personelPerno = this.personel.PerNo.trim();
            }
          }
        });
      },
      changeRequestType() {
        this.search();
      },
      changePersonelByName() {
        //debugger
        this.personelPerno = this.personel.PerNo.trim();
        this.search();
      },
      changePersonelPerno() {
        var personel = this.personelList.find(
          (item) => item.PerNo.trim() == this.personelPerno
        );
        if (personel) {
          this.personel = personel;
        } else {
          this.personel = "";
        }
        this.search();
      },
      search() {
        //debugger
        var PerNo = "-1";
        if (this.personel && this.personel?.PerNo.trim()) {
          PerNo = this.personel?.PerNo.trim();
        } else if (this.personelPerno) {
          PerNo = this.personelPerno;
        }
  
        
  
        var searchParams = {
          beginDate: this.beginDate,
          endDate: this.endDate,
          searchKind: this.requestType.Code,
          perno: PerNo,
        };
        if(this.requestType.Code==5){
          // this.requestType.Code=2
          searchParams.searchKind=2
        }
  //debugger
        this.$emit("search", searchParams);
      },
    },
  };
  </script>
  
  <style scoped>
  .v-input--selection-controls {
    margin: 0;
  }
  
  ::v-deep .management-checkbox .v-label {
    font-size: 0.9rem;
    text-align: right;
  }
  </style>